import { render, staticRenderFns } from "./TemplateObjectEditor.vue?vue&type=template&id=166c9393&scoped=true"
import script from "./TemplateObjectEditor.vue?vue&type=script&lang=js"
export * from "./TemplateObjectEditor.vue?vue&type=script&lang=js"
import style0 from "./TemplateObjectEditor.vue?vue&type=style&index=0&id=166c9393&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166c9393",
  null
  
)

export default component.exports